const CURRENCY = 'RM';

export const formatCurrency = (amount) => {
  return `${CURRENCY} ${amount.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const parseFormula = (formulaString, spaPrice, isChainLogic = false) => {
  if (!formulaString || !formulaString.trim()) {
    return { rebates: [], cashbacks: [], totalRebate: 0, totalCashback: 0 };
  }

  const parts = formulaString.split('+').map(p => p.trim()).filter(p => p);
  const rebates = [];
  const cashbacks = [];
  let totalRebate = 0;
  let totalCashback = 0;
  let remainingPrice = spaPrice;

  parts.forEach(part => {
    if (part.includes('%') || (!part.includes('%') && parseFloat(part) < 100)) {
      const percentage = parseFloat(part.replace('%', ''));
      if (!isNaN(percentage)) {
        if (isChainLogic) {
          // Chain logic: calculate from remaining balance
          const rebateAmount = (remainingPrice * percentage) / 100;
          rebates.push({ percentage, amount: rebateAmount, base: remainingPrice });
          totalRebate += rebateAmount;
          remainingPrice -= rebateAmount;
        } else {
          // Flat logic: calculate from original SPA Price
          const rebateAmount = (spaPrice * percentage) / 100;
          rebates.push({ percentage, amount: rebateAmount });
          totalRebate += rebateAmount;
        }
      }
    } else {
      const flatAmount = parseFloat(part);
      if (!isNaN(flatAmount)) {
        cashbacks.push(flatAmount);
        totalCashback += flatAmount;
      }
    }
  });

  return { rebates, cashbacks, totalRebate, totalCashback };
};

export const calculateSPA = (grossPrice, isBumi, bumiPercentage = 7) => {
  if (isBumi) {
    return grossPrice * (1 - (bumiPercentage / 100));
  }
  return grossPrice;
};

export const calculateNettDownPayment = (spaPrice, totalRebate, totalCashback, dpPercentage = 10) => {
  const downPayment = (spaPrice * (dpPercentage / 100)) - totalRebate - totalCashback;
  return downPayment;
};

export const generateWhatsAppMessage = (data) => {
  const { name, grossPrice, spaPrice, isBumi, bumiPercentage, totalRebate, totalCashback, nettPrice, nettDownPayment, dpPercentage } = data;
  
  let message = `*RebatePro Calculation*\n\n`;
  if (name) {
    message += `*Project:* ${name}\n`;
  }
  message += `*Gross Price:* ${formatCurrency(grossPrice)}\n`;
  if (isBumi) {
    message += `*Bumi Discount:* ${bumiPercentage || 7}%\n`;
  }
  message += `*SPA Price:* ${formatCurrency(spaPrice)}\n`;
  message += `*Total Rebate:* ${formatCurrency(totalRebate)}\n`;
  message += `*Total Cashback:* ${formatCurrency(totalCashback)}\n`;
  message += `*Nett Price:* ${formatCurrency(nettPrice)}\n`;
  if (nettDownPayment !== null && nettDownPayment !== undefined) {
    if (nettDownPayment >= 0) {
      message += `*Actual Cash Upfront (${dpPercentage || 10}% DP):* ${formatCurrency(nettDownPayment)}\n`;
    } else {
      message += `*Cashback to Buyer (${dpPercentage || 10}% DP):* ${formatCurrency(Math.abs(nettDownPayment))}\n`;
    }
  }
  message += `\nCalculated with RebatePro`;
  
  return encodeURIComponent(message);
};

export const saveToLocalStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to save to localStorage:', error);
  }
};

export const loadFromLocalStorage = (key) => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Failed to load from localStorage:', error);
    return null;
  }
};